import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const LoaderContext = createContext({
  show: () => {},
  hide: () => {},
  visible: false,
});

export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {
  const [count, setCount] = useState(0);
  const [watchdog, setWatchdog] = useState(null);
  const show = useCallback(() => {
    setCount((c) => {
      const next = c + 1;
      // eslint-disable-next-line no-console
      console.debug('Loader show ->', next);
      return next;
    });
  }, []);

  const hide = useCallback(() => {
    setCount((c) => {
      const next = Math.max(0, c - 1);
      // eslint-disable-next-line no-console
      console.debug('Loader hide ->', next);
      return next;
    });
  }, []);

  const reset = useCallback(() => {
    setCount(0);
    // eslint-disable-next-line no-console
    console.debug('Loader reset -> 0');
  }, []);

  // Attach global axios interceptors so any axios request will show/hide loader
//   useEffect(() => {
//     const req = axios.interceptors.request.use((config) => {
//       // Allow skipping loader per-request by setting header `X-SKIP-LOADER: true`
//       const skip = config && config.headers && (config.headers['X-SKIP-LOADER'] === '1' || config.headers['X-SKIP-LOADER'] === true || config.headers['x-skip-loader'] === '1');
//       if (!skip) show();
//       return config;
//     }, (error) => {
//       hide();
//       return Promise.reject(error);
//     });

//     const res = axios.interceptors.response.use((response) => {
//       const cfg = response && response.config;
//       const skip = cfg && cfg.headers && (cfg.headers['X-SKIP-LOADER'] === '1' || cfg.headers['X-SKIP-LOADER'] === true || cfg.headers['x-skip-loader'] === '1');
//       if (!skip) hide();
//       return response;
//     }, (error) => {
//       const cfg = error && error.config;
//       const skip = cfg && cfg.headers && (cfg.headers['X-SKIP-LOADER'] === '1' || cfg.headers['X-SKIP-LOADER'] === true || cfg.headers['x-skip-loader'] === '1');
//       if (!skip) hide();
//       return Promise.reject(error);
//     });

//     return () => {
//       axios.interceptors.request.eject(req);
//       axios.interceptors.response.eject(res);
//     };
//   }, [show, hide]);

  // Watchdog: if loader stays visible for too long, reset it to avoid stuck state
  useEffect(() => {
    if (count > 0) {
      // clear previous watchdog
      if (watchdog) clearTimeout(watchdog);
      const id = setTimeout(() => {
        // eslint-disable-next-line no-console
        console.warn('Loader watchdog triggered — resetting loader state.');
        reset();
      }, 30000); // 30s
      setWatchdog(id);
    } else {
      if (watchdog) {
        clearTimeout(watchdog);
        setWatchdog(null);
      }
    }
    return () => {
      if (watchdog) clearTimeout(watchdog);
    };
  }, [count, watchdog, reset]);

  const value = {
    show,
    hide,
    reset,
    visible: count > 0,
    count,
  };

  return (
    <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>
  );
};

export default LoaderContext;
